import { Component, Inject, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";

@Component({
  selector: "app-confirm-unlock-dialog",
  templateUrl: "./confirm-unlock-dialog.component.html",
  styleUrls: ["./confirm-unlock-dialog.component.scss"],
})
export class ConfirmUnlockDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialogRef<ConfirmUnlockDialogComponent>,
  ) {}
  cancel() {
    this.dialog.close(false);
  }
  ok() {
    this.dialog.close(true);
  }
}
